export const loginUrl = process.env.REACT_APP_LOGIN_URL